import React, { useState } from "react";
import Svg, { Path, SvgUri, SvgXml } from "react-native-svg";
import {
  Image,
  TouchableOpacity,
  StyleSheet,
  Button,
  ScrollView,
  View,
  Text,
  Dimensions,
} from "react-native";
import AppConfig from "../config/AppConfig";
import SvgView from "../cards/SvgView";

import { isWeb, trackClick } from "../helpers/utils";
import Animation from "./v3/animation/LotieView";

const { height: HEIGHT, width: WIDTH } = Dimensions.get("window");

const animData = require("../pages/v3/animation/data/LoginAnim").default;
const onboardingScreens = require("../pages/v3/animation/data/OnboardingScreens")
  .default;

export default class PageWelcome extends React.Component {
  constructor(props) {
    super(props);
    this.controller = props.controller;
    this.animation = null;
    this.isRunning = false;
    this.state = { animationDone: false, data: null };
  }

  componentDidMount = () => {
    this.startAnimation();

    if (isWeb) {
      fetch(onboardingScreens[0]?.data[0]);
    }

    //this.retrieveDataIfNeeded();
  };

  componentDidUpdate = () => {
    let restartAnim = false;
    if (AppConfig.USE_NAVIGATION && this.props.navigation) {
      const state = this.props.navigation.dangerouslyGetState ? this.props.navigation.dangerouslyGetState() : this.props.navigation.getState();
      const route = state.routeNames[state.index];
      restartAnim = route === "welcome";
    }
    if (!this.isRunning && restartAnim) {
      this.startAnimation();
    }
  };

  startAnimation() {
    this.isRunning = true;
    setTimeout(() => {
      if (this.animation != null) this.animation.play();
    }, 300);
    this.redirectTimer = setTimeout(() => {
      console.log("Redirect");
      this.onAnimationFinish();
    }, 7000);
  }

  retrieveDataIfNeeded() {
    if (isWeb) {
      const src = animData.login.data;

      if (src != null) {
        fetch(src)
          .then((response) => response.json())
          .then((imageData) => {
            this.setState({
              data: imageData,
            });
            this.startAnimation();
          });
      }
    } else {
      this.startAnimation();
    }
  }

  render() {
    const isAuth = this.controller.isAuth();
    const onNext = this.onNext.bind(this);
    const onLogin = this.onLogin.bind(this);

    const { animationDone, data } = this.state;

    const justify = isWeb ? "center" : "flex-end";
    const svgURL = AppConfig.API_URL + "/svg?login";

    const animStyle = {
      position: "absolute",
      top: 0,
      left: 0,
      zIndex: 100,
      width: isWeb ? Math.min(WIDTH, AppConfig.MAX_WIDTH) : WIDTH,
      transform: [{ translateY: isWeb ? -25 : 0 }, { translateX: 0 }],
    };

    //const src = isWeb ? data : animData.login.data;
    const isLoggedIn = !!this.controller.state?.currentUser;
    const src = isLoggedIn
      ? require("../assets/animations/intro_logged_in.json")
      : require("../assets/animations/intro_login.json");

    const parentStyle = isWeb ? styles.svg : animStyle;

    return (
      <View style={{ alignItems: "center", justifyContent: justify, flex: 1 }}>
        <View style={parentStyle}>
          {!animationDone ? (
            <Animation
              ref={(ref) => {
                this.animation = ref;
              }}
              style={animStyle}
              source={src}
              onAnimationFinish={() => this.onAnimationFinish()}
              autoplay={false}
              loop={false}
            />
          ) : (
            <TouchableOpacity onPress={() => this.onLogin()}>
              {isWeb ? (
                <>
                  <SvgView style={styles.svg} uri={svgURL} />
                  <Image
                    style={[
                      styles.svg,
                      { position: "absolute", top: 0, left: 0, opacity: 0 },
                    ]}
                    source={{ uri: svgURL }}
                  />
                </>
              ) : (
                <SvgUri style={styles.svg} uri={svgURL} />
              )}
            </TouchableOpacity>
          )}
        </View>
      </View>
    );
  }

  onAnimationFinish() {
    if (!this.isRunning) return;

    this.isRunning = false;
    if (this.redirectTimer != null) clearTimeout(this.redirectTimer);

    //this.setState({ animationDone: true });
    if (this.controller.hasNavigation()) {
      if (this.props.isLoggedIn) {
        this.onNext();
      } else {
        console.log("> Navigate onboarding");
        this.props.navigation.navigate("onboarding");
      }
    } else {
      const isLoggedIn = !!this.controller.state?.currentUser;
      if (isLoggedIn) {
        this.controller.changePage("rn:home_card");
      } else {
        this.controller.changePage("rn:onboarding");
      }
    }
  }

  onNext() {
    this.isRunning = false;
    if (this.controller.hasNavigation()) {
      this.props.navigation.replace("mana");
    } else {
      this.controller.changePage("feed");
    }
  }

  onLogin() {
    this.isRunning = false;
    if (this.controller.hasNavigation()) {
      console.log("> Navigate login");
      this.props.navigation.navigate("login");
    } else {
      this.controller.changePage("login");
    }
  }
}

const styles = StyleSheet.create({
  svg: {
    width: 383,
    height: 820,
  },
});
